import { sendIpcClickNotification } from 'Utils/ipcRendererEvents';

/**
 * Bring the application to the foreground when a desktop notification is clicked.
 *
 * `window.focus()` cannot restore a minimized Electron window. The existing
 * `click-notification` IPC asks the main process to restore, show, and focus it.
 */
export const handleDesktopNotificationClick = (
  notification: Notification,
  tag: string
): void => {
  sendIpcClickNotification(tag);

  if (parent) {
    parent.focus();
  }

  window.focus();
  notification.close();
};
